module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/brand-icons-c1868c9545d2de1cf8488f1dadd8c9d0.eot";